import React from "react";
import RefinementList from "components/search/base/RefinementList";
import gradeLevelCategories from "components/search/references/gradeLevelCategories";

const GradeLevelRefinementList = () => {
  return (
    <RefinementList
      attribute="gradeLevel"
      categories={gradeLevelCategories}
      limit={100}
      title="Grade Level"
    />
  );
};

export default GradeLevelRefinementList;
